/**
 * Created by iamso on 21.06.19.
 */

const MineSweeperNode = cc.Node.extend({
    ctor: function (game) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.styles.MineSweeperNode);

        this.game = game;

        this.createField();
        this.createScore();
        this.createProgress();
        this.createBucket();

        this.game.on("open", this.open.bind(this), this);
        this.game.on("bomb", this.bomb.bind(this), this);
        this.game.on("prize", this.prize.bind(this), this);
        this.game.on("explodePrize", this.explodePrize.bind(this), this);
        this.game.on("openField", this.openField.bind(this), this);
        this.game.on("showBomb", this.showBomb.bind(this), this);
        this.game.on("removeFlag", this.removeFlag.bind(this), this);
        this.game.on("addFlag", this.addFlag.bind(this), this);
        this.game.on("showPrize", this.showPrize.bind(this), this);
        this.game.on("victory", this.onVictory.bind(this), this);
        this.game.on("cellsToOpen", this.updateProgress.bind(this), this);

        this.createBg();
        this.controls();

        this.onResize();
    },

    onVictory: function () {
        this.hideTopBlock();
        this.hideFieldNode();
        this.hideProgress();
    },

    createBg: function () {
        const bg = new cleverapps.Spine(bundles.minesweeper.jsons.field_bg);
        bg.setAnimation(0, "animation", true);
        bg.setAlignment(cleverapps.styles.MineSweeperNode.bg);
        this.addChild(bg, -1);
    },

    createBucket: function () {
        const styles = cleverapps.styles.MineSweeperNode.bucket;
        this.bucket = new cc.Node();
        this.bucket.setLocalZOrder(10);
        this.bucket.setAnchorPoint(0.5, 0.5);
        this.bucket.setContentSize2(styles);
        this.addChild(this.bucket);

        const image = this.image = new cc.Sprite(bundles.minesweeper.frames.bucket_png);
        this.bucket.addChild(image);

        let flyFlag;
        cleverapps.UI.onDrag(this.bucket, {
            onDragStart: function () {
                if (!this.game.running || this.game.paused) {
                    return false;
                }
                flyFlag = this.getFlyFlag();
                return true;
            }.bind(this),

            onDragMoveNotThrottled: function (touch) {
                if (flyFlag && flyFlag.parent) {
                    flyFlag.setPosition(flyFlag.parent.convertTouchToNodeSpace(touch));
                }
            },

            onDragEnd: function (touch) {
                if (flyFlag && flyFlag.parent) {
                    const index = this.calculateIndex(touch.getLocation());
                    if (index && this.game.hasElement(index.col, index.row) && this.game.running && !this.game.paused && (!this.game.flags || !this.game.flags[index.row][index.col])) {
                        this.game.switchFlag(index.col, index.row);
                    } else {
                        this.removeFlyFlag();
                    }
                }
            }.bind(this)
        });

        cleverapps.UI.applyHover(this.bucket, {
            filter: function () {
                return this.game.running && !this.game.paused;
            }.bind(this)
        });
    },

    hideFieldNode: function () {
        cc.Base.PerformRecursive(this.fieldNode, (node) => {
            node.setCascadeOpacityEnabled(true);
        });
        this.fieldNode.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf()
        ));
    },

    hideTopBlock: function () {
        this.topBlock.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf()
        ));
    },

    removeFlag: function (options) {
        const animation = this.field[options.row][options.col];
        if (animation.flag) {
            if (!options.silent) {
                this.removeFlyFlag();
                const flag = this.getFlyFlag({
                    pos: animation.flag.getPosition(),
                    parent: animation
                });
                flag.replaceParentSamePlace(this.bucket);
                this.removeFlyFlag();
            }

            animation.flag.removeFromParent();
            animation.flag = undefined;
        }
    },

    getFlyFlag: function (options) {
        if (!this.flyFlag) {
            const styles = cleverapps.styles.MineSweeperNode.flag;
            options = options || {};
            const pos = options.pos || styles.bucket;
            const parent = options.parent || this.bucket;
            const scale = options.parent ? 1 : styles.bucket.scale;
            this.flyFlag = new cc.Sprite(bundles.minesweeper.frames.flag_png);
            this.flyFlag.setScale(scale);
            parent.addChild(this.flyFlag);
            this.flyFlag.setAlignment(pos);
        }
        return this.flyFlag;
    },

    getFlyFlagTime: function (pos) {
        const flyFlag = this.getFlyFlag();
        const time = cc.pDistance(flyFlag.getPosition(), pos) / cleverapps.styles.MineSweeperNode.flag.speed;
        return Math.max(time, 0.15);
    },

    removeFlyFlag: function () {
        if (this.flyFlag) {
            const pos = cleverapps.styles.MineSweeperNode.flag.bucket;
            const time = this.getFlyFlagTime(pos);
            this.flyFlag.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.MoveTo(time, pos),
                    new cc.ScaleTo(time, cleverapps.styles.MineSweeperNode.flag.bucket.scale)
                ),
                new cc.RemoveSelf()
            ));
            this.flyFlag = undefined;
        }
    },

    addFlag: function (options) {
        const styles = cleverapps.styles.MineSweeperNode.flag;
        const animation = this.field[options.row][options.col];
        const flyFlag = this.getFlyFlag();
        const pos = flyFlag.parent.convertToNodeSpace(animation.convertToWorldSpace(cc.p(animation.width / 2, animation.height / 2)));
        const time = this.getFlyFlagTime(pos);
        flyFlag.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.MoveTo(time, pos),
                new cc.ScaleTo(time, 1)
            ),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                if (this.game.flags[options.row][options.col]) {
                    animation.flag = new cc.Sprite(bundles.minesweeper.frames.flag_png);
                    animation.addChild(animation.flag);
                    animation.flag.setAlignment(styles.stableCell);
                }
            })
        ));
        this.flyFlag = undefined;
    },

    controls: function () {
        cleverapps.UI.onClick(this.fieldNode, this.onClicked.bind(this), {
            interactiveScale: false,
            filter: function () {
                return this.game.running && !this.game.paused && !this.hammerAnimation;
            }.bind(this)
        });
    },

    calculateIndex: function (pos) {
        const location = this.fieldNode.convertToNodeSpace(pos);
        const rect = cc.rect(0, 0, this.fieldNode.width, this.fieldNode.height);
        if (cc.rectContainsPoint(rect, location)) {
            const styles = cleverapps.styles.MineSweeperNode.field.cell;
            const col = Math.floor(location.x / styles.width);
            const row = Math.floor(location.y / styles.height);
            return {
                row: Math.max(Math.min(row, MineSweeper.HEIGHT - 1), 0),
                col: Math.max(Math.min(col, MineSweeper.WIDTH - 1), 0)
            };
        }
    },

    onClicked: function (touch) {
        const startIndex = this.calculateIndex(touch.getStartLocation());
        const index = this.calculateIndex(touch.getLocation());

        if (index && startIndex && index.row === startIndex.row && index.col === startIndex.col && this.game.hasElement(index.col, index.row)) {
            if (touch.getButton() !== 0 || (this.game.flags && this.game.flags[index.row][index.col])) {
                this.game.switchFlag(index.col, index.row);
                return;
            }

            const styles = cleverapps.styles.MineSweeperNode.hammer;
            this.hammerAnimation = true;
            const hammer = new cleverapps.Spine(bundles.minesweeper.jsons.custom_cursor_json);
            hammer.setScale(styles.scale || 1.0);
            const animation = this.field[index.row][index.col];
            hammer.setAlignment(styles);
            hammer.setLocalZOrder(10);
            animation.getParent().addChild(hammer);
            hammer.replaceParentSamePlace(this);

            hammer.setAnimation(0, "animation", false);
            hammer.setCompleteListener(() => {
                hammer.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.15, 0),
                    new cc.RemoveSelf()
                ));
            });

            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.35),
                new cc.CallFunc(() => {
                    this.hammerAnimation = false;
                    this.game.open(index.col, index.row);
                    this.updateRewardsAmount(this.rewardTimeouts, 0.65);
                    this.rewardTimeouts = undefined;
                })
            ));
        }
    },

    createScore: function () {
        const styles = cleverapps.styles.MineSweeperNode;
        this.scores = {};

        const types = [MineSweeper.ELEMENT_RUBY, MineSweeper.ELEMENT_ENERGY, MineSweeper.ELEMENT_COIN, MineSweeper.ELEMENT_CHEST];

        const scores = types.map(function (type) {
            const icon = this.createRewardIcon(type);
            icon.setScale(styles.topBlock.icon.scale);

            const rewardText = cleverapps.UI.generateImageText("0", cleverapps.styles.FONTS.MINESWEEPER_TEXT_TOP);
            rewardText.setLocalZOrder(1);
            rewardText.baseScale = rewardText.scale;

            const score = new cleverapps.Layout([rewardText, icon], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.topBlock.scoreMargin
            });
            score.rewardText = rewardText;
            this.scores[type] = score;
            score.setCascadeOpacityEnabled(true);
            return score;
        }, this);

        const scoresNode = new cleverapps.Layout(scores, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.topBlock.betweenScores
        });
        scoresNode.setCascadeOpacityEnabled(true);

        const text = cleverapps.UI.generateOnlyText(Messages.get("minesweeper.prize"), cleverapps.styles.FONTS.MINESWEEPER_TEXT_TOP);

        const topBlock = this.topBlock = new cleverapps.Layout([text, scoresNode], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.topBlock.margin
        });
        this.addChild(topBlock);
        topBlock.setCascadeOpacityEnabled(true);
        topBlock.setAlignment(styles.topBlock);
    },

    createField: function () {
        const styles = cleverapps.styles.MineSweeperNode.field;
        this.field = [];

        for (let row = 0; row < this.game.height; row++) {
            const itemsRow = [];

            for (let col = 0; col < this.game.width; col++) {
                const item = new cleverapps.Spine(bundles.minesweeper.jsons.minesweeper);
                item.setContentSize(styles.cell);
                item.spine.setPosition(item.width / 2, item.height / 2);
                item.setSkin((row + col) % 2 === 0 ? "1" : "2");
                item.setAnimation(0, "idle", true);
                cleverapps.UI.applyHover(item);
                itemsRow.push(item);
            }

            this.field.push(itemsRow);
        }

        const lines = this.field.map((row) => new cleverapps.Layout(row.map((animation) => {
            const wrap = new cc.Node();
            wrap.setAnchorPoint(0.5, 0.5);
            wrap.setContentSize2(styles.cell.width, styles.cell.height);
            animation.setAlignment(wrap.width / 2, wrap.height / 2);
            wrap.addChild(animation);
            return wrap;
        }), {
            direction: cleverapps.UI.HORIZONTAL
        }));

        this.fieldNode = new cleverapps.Layout(lines, {
            direction: cleverapps.UI.VERTICAL,
            reversed: true
        });
        this.addChild(this.fieldNode);
        this.fieldNode.setAlignment(styles);
    },

    openField: function () {
        for (let i = 0; i < this.field.length; i++) {
            for (let j = 0; j < this.field[i].length; j++) {
                const item = this.field[i][j];
                if (this.game.hasElement(j, i)) {
                    item.setAnimation(1, "boom", false);
                }
            }
        }
    },

    createProgress: function () {
        const styles = cleverapps.styles.MineSweeperNode.progress;

        this.cellsToOpenProgress = new ScaledProgressBar({
            progress: bundles.minesweeper.frames.bar_minesweeper
        });
        this.cellsToOpenProgress.setAnchorPoint(0, 0.5);
        this.cellsToOpenProgress.setLength(styles.width);
        this.cellsToOpenProgress.setAlignment(styles);
        this.addChild(this.cellsToOpenProgress);
        this.cellsToOpenProgress.setCascadeOpacityEnabled(true);

        this.cellsToOpen = cleverapps.UI.generateImageText(`0/${this.game.cellsToOpen}`, cleverapps.styles.FONTS.MINESWEEPER_PROGRESS);
        this.cellsToOpen.baseScale = this.cellsToOpen.scale;
        this.cellsToOpen.total = this.game.cellsToOpen;
        this.cellsToOpen.setAlignment(styles.text);
        this.cellsToOpenProgress.addChild(this.cellsToOpen);
    },

    updateProgress: function (amount) {
        this.cellsToOpenProgress.setGoal(this.cellsToOpen.total);
        this.cellsToOpenProgress.setPercentage(this.cellsToOpen.total - amount, {
            animated: true
        });

        this.cellsToOpen.setString(`${this.cellsToOpen.total - amount}/${this.cellsToOpen.total}`);
        this.cellsToOpen.stopAllActions();
        this.cellsToOpen.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, 1.3 * this.cellsToOpen.baseScale),
            new cc.ScaleTo(0.15, 1 * this.cellsToOpen.baseScale)
        ));
    },

    hideProgress: function () {
        this.cellsToOpenProgress.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf()
        ));
    },

    bomb: function (options) {
        const animation = this.field[options.row][options.col];
        animation.setLocalZOrder(1);
        animation.replaceParentSamePlace(this);
        animation.bomb.removeFromParent();
        animation.setAnimation(2, "bomb", false);
    },

    showBomb: function (options) {
        const animation = this.field[options.row][options.col];
        const bomb = animation.bomb = new cleverapps.Spine(bundles.minesweeper.jsons.minesweeper);
        bomb.setLocalZOrder(animation.getLocalZOrder() - 1);
        animation.getParent().addChild(bomb);
        bomb.setAlignment(animation.getPosition());
        bomb.setAnimation(0, "bomb_idle", false);
    },

    createRewardIcon: function (type) {
        if (type === MineSweeper.ELEMENT_CHEST) {
            const icon = UnitView.getUnitImage(UnitsLibraryHelper.ResolveUnit({ type: "reschest", stage: 0 }), { preferStatic: true });
            cleverapps.UI.fitToBox(icon, { ...cleverapps.styles.MineSweeperNode.topBlock.icon.box, maxScale: 2 });
            return icon;
        }
        return new cc.Sprite(this.getRewardIcon(type));
    },

    getRewardIcon: function (type) {
        switch (type) {
            case MineSweeper.ELEMENT_RUBY:
                return bundles.menubar.frames.gold_png;
            case MineSweeper.ELEMENT_ENERGY:
                return cleverapps.skins.getSlot("menubar_life_png") || bundles.menubar.frames.menubar_life_png;
            case MineSweeper.ELEMENT_COIN:
                return bundles.menubar.frames.coin_png;
        }
    },

    createReward: function (options) {
        const animation = this.field[options.row][options.col];

        const icon = this.createRewardIcon(options.prize.type);
        icon.setScale(0.9);

        const reward = new cc.Node();
        reward.setAnchorPoint(0.5, 0.5);
        reward.setContentSize2(cleverapps.styles.MineSweeperNode.field.cell);

        reward.addChild(icon);
        icon.setAlignment(reward.width / 2, reward.height / 2);

        reward.setAlignment(animation.getPosition());
        reward.setCascadeOpacityEnabled(true);
        reward.setLocalZOrder(1);
        animation.getParent().addChild(reward);

        return reward;
    },

    showPrize: function (options) {
        const reward = this.createReward(options);
        reward.runAction(new cc.Spawn(
            new cc.ScaleTo(1, 1).easing(cc.easeBackOut()),
            new cc.FadeIn(1)
        ));
    },

    explodePrize: function (options) {
        this.updateRewardAmount(options);
        this.updateRewardsAmount(this.rewardTimeouts, 0.15);
        const styles = cleverapps.styles.MineSweeperNode.explodePrize;

        const flyOneIcon = function (icon) {
            const dist = {
                x: Math.random() * 2 * styles.dx - styles.dx,
                y: styles.dy
            };

            const time = 0.6 + Math.random() * 0.3;
            icon.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.RotateBy(time, 150 + Math.random() * 150),
                    new cc.ScaleTo(time, 1.4),
                    new cc.JumpAnimation(time, icon, dist, styles.h + Math.random() * styles.dh)
                ),
                new cc.RemoveSelf()
            ));
        };

        let amount = -options.amount;
        if (amount > 8) {
            amount = 8;
        }
        for (let i = 0; i < amount; i++) {
            const icon = this.createRewardIcon(options.type);
            icon.setScale(0.9);
            const target = this.scores[options.type];
            target.getParent().addChild(icon);
            icon.setPosition(target.getPosition());
            flyOneIcon(icon);
        }
    },

    prize: function (options) {
        const reward = this.createReward(options);
        this.updateRewardAmount(options.prize);
        reward.runAction(new cc.Sequence(
            new cc.ScaleTo(0, reward.scale * 0.5),
            StandartAnimations.jumpCollect(reward, this.scores[options.prize.type], {
                jumpScale: reward.scale * 1.2,
                collectScale: reward.scale,
                collectSoundEffect: "minesweeper.vin"
            }),
            new cc.RemoveSelf()
        ));
    },

    open: function (options) {
        const animation = this.field[options.row][options.col];
        animation.setAnimation(1, "boom", false);
        cleverapps.effects.fire("minesweeper.pickaxe");

        if (options.bombs) {
            const bombs = cleverapps.UI.generateImageText(options.bombs, cleverapps.styles.FONTS.MINESWEEPER_BOMBS);
            animation.getParent().addChild(bombs);
            bombs.setColor(cleverapps.styles.MineSweeperNode.bombs[`color${options.bombs}`]);
            bombs.setAlignment(cleverapps.styles.MineSweeperNode.bombs);
        }

        if (options.bomb) {
            this.showBomb(options);
            cleverapps.effects.fire("minesweeper.miner.fail");
        } else {
            cleverapps.effects.fire("minesweeper.miner.good");
        }
    },

    updateRewardAmount: function (options) {
        if (!this.rewardTimeouts) {
            this.rewardTimeouts = {};
        }
        if (!this.rewardTimeouts[options.type]) {
            this.rewardTimeouts[options.type] = 0;
        }

        this.rewardTimeouts[options.type] += options.amount;
    },

    updateRewardsAmount: function (rewardTimeouts, delay) {
        rewardTimeouts = rewardTimeouts || {};
        delay = delay || 0;

        for (const type in rewardTimeouts) {
            if (!rewardTimeouts[type]) {
                return;
            }

            const rewardText = this.scores[type].rewardText;
            const deltaPosition = this.convertToNodeSpace(rewardText.parent.convertToWorldSpace(rewardText.getPosition()));
            deltaPosition.y += cleverapps.styles.MineSweeperNode.prize.delta;

            this.scores[type].runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.Sequence(
                    new cc.CallFunc(function (type) {
                        this.scores[type].rewardText.setString(this.game.reward[type]);
                        this.scores[type].rewardText.runAction(new cc.Sequence(
                            new cc.ScaleTo(0.1, 1.4 * this.scores[type].rewardText.baseScale),
                            new cc.ScaleTo(0.25, 1 * this.scores[type].rewardText.baseScale)
                        ));

                        cleverapps.aims.showDelta(rewardTimeouts[type], this, {
                            x: deltaPosition.x,
                            y: deltaPosition.y
                        });
                    }.bind(this, type))
                )
            ));
        }
    },

    onResize: function () {
        const styles = cleverapps.styles.MineSweeperNode.bucket;

        this.bucket.setAlignment(styles.position);

        this.image.setScale(styles.scale[cleverapps.resolution.mode]);
        this.image.setAlignment(styles.image);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MINESWEEPER_BOMBS: {
        name: "default",
        size: 70,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MINESWEEPER_TEXT_TOP: {
        name: "default",
        size: 55,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MINESWEEPER_PROGRESS: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MINESWEEPER_TEXT_EXIT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.MineSweeperNode = {
    width: 1020,
    height: 1260,

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },

    topBlock: {
        margin: 0,
        betweenScores: 60,
        scoreMargin: 17,
        x: { align: "center" },
        y: { align: "top", dy: -13 },
        icon: {
            scale: 0.7,
            box: {
                width: 78,
                height: 77
            }
        }
    },

    field: {
        x: { align: "center" },
        y: { align: "center", dy: -57 },

        cell: {
            width: 123,
            height: 123
        }
    },

    progress: {
        x: { align: "center", dx: 11 },
        y: { align: "bottom", dy: 25 },
        width: 960,
        text: {
            x: { align: "center" },
            y: { align: "center", dy: 1 }
        }
    },

    loseText: {
        x: { align: "center" },
        y: { align: "top", dy: 200 }
    },

    prize: {
        dx: 100,
        dy: 50,
        margin: 20,
        padding: 0,
        delta: 30
    },

    explodePrize: {
        dx: 1000,
        dy: -1500,
        h: 1200,
        dh: 400
    },

    reward: {
        amount: {
            x: { align: "center", dx: 20 },
            y: { align: "bottom", dy: 0 }
        }
    },

    hammer: {
        x: { align: "center" },
        y: { align: "center" },
        scale: 1.2
    },

    bucket: {
        position: [{
            x: { align: "right", dx: 0 },
            y: { align: "bottom", dy: -100 }
        }, {
            x: { align: "right", dx: 256 },
            y: { align: "bottom", dy: -71 }
        }, {
            x: { align: "right", dx: 256 },
            y: { align: "bottom", dy: -71 }
        }],
        scale: [1, 1.5, 1.5],
        width: 200,
        height: 250,
        image: {
            x: { align: "center", dx: 30 },
            y: { align: "center", dy: 20 }
        }
    },

    flag: {
        bucket: {
            x: 150,
            y: 230,
            scale: 2
        },
        cell: {
            x: 155,
            y: 53
        },
        stableCell: {
            x: { align: "center" },
            y: { align: "center" }
        },
        speed: 4000
    },

    bombs: {
        x: { align: "center" },
        y: { align: "center", dy: -3 },
        "color1": new cc.Color(62, 113, 235, 255),
        "color2": new cc.Color(56, 215, 66, 255),
        "color3": new cc.Color(219, 81, 46, 255),
        "color4": new cc.Color(222, 207, 42, 255),
        "color5": new cc.Color(189, 67, 204, 255),
        "color6": new cc.Color(79, 178, 183, 255),
        "color7": new cc.Color(218, 57, 84, 255),
        "color8": new cc.Color(100, 49, 221, 255)
    }
};
